import { createAction, props } from '@ngrx/store';
import { TrendModel } from '../../../shared/data/models/trend.model';

export const loadHashTag = createAction(
  '[HashTag] Load Hash Tags',
  props<{ count?: number }>()
);

export const loadHashTagSuccess = createAction(
  '[HashTag] Load Hash Tags Success',
  props<{ trending: TrendModel[] }>()
);

export const loadHashTagError = createAction(
  '[HashTag] Load Hash Tags Error',
  props<{ error: string }>()
);
